import { TRACKING_COOKIES } from '@/constants/cookies';
import { sendGTMEvent } from '@next/third-parties/google';
import { getCookie } from 'cookies-next';

export const useSendGTMEvent = () => {
  const isGTMConsentGiven = getCookie(TRACKING_COOKIES.GTM) === 'true';

  const sendEvent = (data: Object) => {
    if (isGTMConsentGiven) {
      sendGTMEvent(data);
    }
  };

  return { sendEvent };
};
